/**
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
*/
window.RCA = window.RCA || {};
window.RCA.login = window.RCA.login || {};

(function (login) {
    'use strict';
    /* Shared state is provided by RCA.shared. */
    window.RCA.shared.localState.layout = window.RCA.shared.localState.layout || [];
    //window.RCA.shared.localState.lang = window.RCA.shared.localState.lang || 'hu';
    /* ----- Hold Ready ------------------------------------------------------------------------------------------------- */
    //$.holdReady(true);

function _ajaxReadyModClient(data) {
    $('.bodycontent').html(data);
    $('main').hide();
    window.RCA.shared.is_ready.html = true;
    //$.holdReady(false);
}

function checkReady() {
    if (window.RCA.shared.is_ready.config && window.RCA.shared.is_ready.html) {
        clearTimeout(window.RCA.shared.waitForReady);
        //$.holdReady(false);
        window.RCA.shared.sharedReady();
        login.loginReady();
    } else {
        window.RCA.shared.waitForReady = setTimeout(function (){
            checkReady();
        }, 100);
    }
}

function forceLogIn(data) {
    if (data) {
       /* $.post('api/', {
            do: 'logIn',
            data: data[Math.floor(Math.random() * data.length)]
        }, function (res) {
            localStorage.setItem('last_logged_in', res.userid);
        });*/
        location.replace(data[Math.floor(Math.random() * data.length)].hash);
    }
}

/* ----- Process on Document Ready ---------------------------------------------------------------------------------- */
function loginReady() {
    var
        img = new Image(),
        reader = new FileReader(),
        canvasElement = document.getElementById('canvas'),
        canvas = canvasElement.getContext("2d"),
        imageData, code;
    login.Layout.Init();
    login.Settings.Init();
    window.RCA.shared.Language.Init();
    login.Modal.Init();

    login.getTranslationsWithoutLogin();

    login.Modulsettings.Init();

    window.RCA.shared.Kiosk.addCameraListener('qr', login.processQr);

    $('select.changeLang')
        .val(window.RCA.shared.localState.lang)
        .on('change', function () {
            window.RCA.shared.Language.Init(this.value);
            login.createForm();
        });
    $('button.qrcode').on('click', function () {
        window.RCA.shared.Kiosk.readqr();
        //$('input[name=qrcode]').trigger('click');
    });
    $('input[name=qrcode]').on('change', evtChangeInput);
    $('#formLogin').on('submit', evtSubmitForm);
    $('#formReg').on('submit', createUser);
    $('#formLostPass').on('submit', lostPass);
    $('#formChangePass').on('submit', changePass);
    $('#formTwofactor').on('submit', twoFactor);

    $('a.lostpass').on('click', function () {
        $("#formLogin").hide();
        $("#formReg").hide();
        $("#formLostPass").show();
    });

    $('a.login').on('click', function () {
        $("#formLogin").show();
        $("#formReg").hide();
        $("#formLostPass").hide();
        $("#formTwofactor").hide();
    });

    $('a.resend_twofactor').on('click', function () {
        $.post('api/', {
            do: 'resendTwoFactor'
        }, function (res) {
            login.Modal.alert(window.RCA.shared.Language.getItem(res.message));
        });
    });

    $("#formLogin .registration, #formLostPass .registration").on("click", function(){
        location.replace("registration.html");
    });

    $(".twofactor input").on("keyup", function (e){
        e.preventDefault();
        var keycode = e.keyCode || e.which;
        if (keycode == 8) {
            $(this).closest(".twofactor").prev(".twofactor").find("input").focus();
        }

        if ($(this).val() != "") {
            $(this).closest(".twofactor").next(".twofactor").find("input").focus();
        }
    });

    login.createForm();

    function createUser(e) {
        e.preventDefault();
        var formData = $(this).serialize();
        formData += "&do=createUser";

        $.post('api/', formData, function (res) {
            if (res.error != undefined) {
                if (res.msg_type != "langfile") {
                    login.Modal.alert(res.message[window.RCA.shared.localState.lang].error_msg);
                } else {
                    login.Modal.alert(window.RCA.shared.Language.getItem(res.message));
                }
                $('#formReg').removeClass("disabled");
            } else {
                if (!res) {
                    login.Modal.alert(window.RCA.shared.Language.getItem('login-error'));
                } else {
                    localStorage.setItem('last_logged_in', res.hash);
                    if (res.id) {
                        location.replace(res.hash);
                    }
                }
            }
        });
    }

    function evtSubmitForm(e) {
        e.preventDefault();
        var
            formData = window.RCA.shared.serializeObject($(this));
        $.post('api/', {
            do: 'logIn',
            data: formData
        }, function (res) {
            if (res.error != undefined) {
                login.Modal.alert(window.RCA.shared.Language.getItem(res.message));
            } else {
                if (!res) {
                    login.Modal.alert(window.RCA.shared.Language.getItem('login-error'));
                } else {
                    if (res.twofactor == "twofactor") {
                        $("#formLogin").hide();
                        $("#formTwofactor").show();
                    } else {
                        localStorage.setItem('last_logged_in', res.qrcode);
                        localStorage.setItem('rca4_current_channel', res.default_channel || "ch0");
                    }
                }
            }
        });
    }

    function twoFactor(e) {
        e.preventDefault();

        var formData = window.RCA.shared.serializeObject($(this));

        $.post('api/', {
            do: 'twoFactor',
            data: formData
        }, function (res) {
            if (res.error != undefined) {
                login.Modal.alert(window.RCA.shared.Language.getItem(res.message));
            } else {
                if (!res) {
                    login.Modal.alert(window.RCA.shared.Language.getItem('login-error'));
                } else {
                    localStorage.setItem('last_logged_in', res.qrcode);
                    localStorage.setItem('rca4_current_channel', res.default_channel || "ch0");
                }
            }
        });
    }

    function lostPass(e) {
        e.preventDefault();
        var
            formData = window.RCA.shared.serializeObject($(this));
        $.post('api/', {
            do: 'lostPass',
            data: formData
        }, function (res) {
            if (res.error) {
                login.Modal.alert(window.RCA.shared.Language.getItem(res.message));
            } else {
                login.Modal.alert(window.RCA.shared.Language.getItem('lostpass-sent'), function () {
                    location.reload();
                });
            }
        });
    }

    function evtChangeInput(e) {
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = function () {
                img.src = this.result;
                img.onload = function () {
                    canvasElement.width = 1080;
                    canvasElement.height = canvasElement.width * (this.height / this.width);
                    canvas.drawImage(this, 0, 0, canvasElement.width, canvasElement.height);
                    imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
                    code = jsQR(imageData.data, imageData.width, imageData.height, {
                        /*inversionAttempts: "dontInvert"*/
                    });
                    if (code && code.data) {
                        if (Number(code.data) >= 1001 && Number(code.data) <= 199999) {
                            var
                                $form = $('#formLogin');
                                $form.find('input[name=user]').val(Number(code.data));
                                $form.find('input[name=pwd]').val('e');
                                $form.trigger('submit');
                                $form = null;
                        } else {
                            login.Modal.alert('QR kód nem tartalmaz belépési információt.');
                        }
                    } else {
                        login.Modal.alert('QR kód olvasása nem sikerült.');
                    }
                };
            };
        }
    }

    if (location.hash) {
        let hashtag = location.hash.replace("#", "");
        history.pushState("", document.title, window.location.pathname);

        if (hashtag == "twofactor") {
            $("#formLogin").remove();
            $("#formLostPass").remove();
            $("#formReg").remove();
            $("#formChangePass").remove();
            $("#formTwofactor").show();
        } else {
            $("#formLogin").remove();
            $("#formLostPass").remove();
            $("#formReg").remove();
            $.ajax({
                url: 'api/',
                method: 'post',
                data: {
                    do: "checkLostPass",
                    hash: hashtag
                },
                success: function (response) {
                    if (response.error) {
                        location.reload();
                    } else {
                        $('#formChangePass [name="lostpass_hash"]').val(hashtag);
                    }
                }
            });
        }
    } else {
        $("#formChangePass").remove();
    }

    function changePass(e) {
        e.preventDefault();
        var
            formData = window.RCA.shared.serializeObject($(this));
        $.post('api/', {
            do: 'changePass',
            data: formData
        }, function (res) {
            if (res.error) {
                login.Modal.alert(window.RCA.shared.Language.getItem(res.message));
            } else {
                login.Modal.alert(window.RCA.shared.Language.getItem('changepass-success'), function(){
                    location.reload();
                });
            }
        });
    }
}

function getRegistrationData() {
    $.ajax({
        method: 'post',
        url: 'api/',
        data: {
            do: 'getRegistrationData'
        },
        success: function (resp) {
            window.RCA.shared.AppData.registration = resp;
            login.createForm();
        }
    });
}

function createForm() {
    switch (window.RCA.shared.AppData.registration.login_type) {
        case "non-sec-plus":
            $("#formLogin").hide();
            $("#formReg").show();
            var regform = $("#formReg");
            var fields_container = $(".fields", regform);

            fields_container.empty();

            for (var f in window.RCA.shared.AppData.registration.fields) {
                var field = window.RCA.shared.AppData.registration.fields[f];

                var p = $("<p/>");
                var label = $("<label/>").addClass("inputgroup flex");
                var i = $("<i/>").addClass(field.icon);
                var input;

                if (field.userfield != "") {
                    input = $("<input/>").attr("name", field.userfield).attr("placeholder", field.label[window.RCA.shared.localState.lang].text);
                    if (field.required) {
                        input.attr("required", "required");
                    }
                    if (field.userfield == "password") {
                        input.attr("type", "password");
                    }
                    if (field.userfield == "email") {
                        input.attr("type", "email");
                    }
                } else if (field.dynamic_user_field != "") {
                    let dufield = window.RCA.shared.AppData.user_fields.find(function (item) {
                        return item.id == field.dynamic_user_field;
                    });
                    input = $("<input/>").attr("name", "values["+dufield.id+"]").attr("placeholder", dufield.label[window.RCA.shared.localState.lang]);
                    if (field.required) {
                        input.attr("required", "required");
                    }
                } else {
                    switch (field.customfield) {
                        case "select":
                            input = $("<select/>").attr("name", field.fieldname);
                            let empty_option = $("<option/>").val("").text(field.label[window.RCA.shared.localState.lang].text);

                            input.append(empty_option);

                            for (let i = 0; i < field.options_num; i++) {
                                let option = $("<option/>").val(field.options.value[i]).text(field.options[window.RCA.shared.localState.lang].label[i]);
                                input.append(option);
                            }

                            break;
                        case "text":
                        default:
                            input = $("<input/>").attr("name", field.fieldname).attr("placeholder", field.label[window.RCA.shared.localState.lang].text);
                            break;
                    }
                    if (field.required) {
                        input.attr("required", "required");
                    }
                }

                label.append(i);
                label.append(input);
                p.append(label);

                fields_container.append(p);
            }

            break;
        case "non-sec":
            $("#formReg").hide();
            $("#formLogin").show();
            if (window.RCA.shared.AppData.registration.default_user) {

                $.ajax({
                    method: 'post',
                    url: 'api/',
                    data: {
                        do: "userExists",
                        id: window.RCA.shared.AppData.registration.default_user
                    },
                    success: function (resp) {
                        if (resp.exists == true) {
                            location.replace(window.RCA.shared.AppData.registration.default_user);
                        }
                    }
                });
            }
            break;
        case "basic-easy":
        case "basic":
        default:
            $("#formReg").hide();
            $("#formLogin").show();

            if (window.RCA.shared.AppData.registration.default_user) {

                $.ajax({
                    method: 'post',
                    url: 'api/',
                    data: {
                        do: "userExists",
                        id: window.RCA.shared.AppData.registration.default_user
                    },
                    success: function (resp) {
                        if (resp.exists == true) {
                            $("[name='user']").val(resp.email);
                            $("[name='pwd']").val(window.RCA.shared.AppData.registration.default_user);
                        }
                    }
                });
            }

            if (window.RCA.shared.AppData.registration.reg_allowed == 1) {
                $("#formLogin .registration").show();
            } else {
                $("#formLogin .registration").hide();
            }

            break;

    }
}

function processQr(code) {

    $.post('api/', {
        do: 'logInByQR',
        data: {
            code: code
        }
    }, function (res) {
        if (!res) {
            login.Modal.alert(window.RCA.shared.Language.getItem('login-error'));
        } else {
            localStorage.setItem('last_logged_in', res.userid);
        }
    });
}

function loginLastUser() {
    $.post('api/', {
        do: 'loginByID',
        data: {
            uid: localStorage.getItem('last_logged_in')
        }
    }, function (res) {
        if (!res) {
            login.Modal.alert(window.RCA.shared.Language.getItem('login-error'));
        } else {
            localStorage.setItem('last_logged_in', res.userid);
        }
    });
}

function getTranslationsWithoutLogin() {
    $.post('api/', {
        do: 'getTranslationsWithoutLogin'
    }, function (data) {
        data.sort(function(a,b) {
            return parseInt(a.sort_id) > parseInt(b.sort_id) ? 1 : -1;
        });
        var loginlanguagesFragment = $(document.createDocumentFragment());
        $.each(data, function(i,e) {
            if(e.active)
                $("<option/>").val(e.translation_id).text(e.translation_name).attr('selected', window.RCA.shared.localState.lang == e.translation_id).appendTo(loginlanguagesFragment);
        });
        $("#landing").find(".changeLang").html(loginlanguagesFragment);

        var actlang = data.find(function (item) {
            return item.translation_id == window.RCA.shared.localState.lang;
        });

        if (actlang == undefined) {
            window.RCA.shared.Language.Init(window.RCA.shared.AppData.settings.lang);
        }

        data = null;
    })
}

    /* ----- Public Namespace API ------------------------------------------------------------------------------------- */
    login._ajaxReadyModClient = _ajaxReadyModClient;
    login.checkReady = checkReady;
    login.forceLogIn = forceLogIn;
    login.loginReady = loginReady;
    login.getRegistrationData = getRegistrationData;
    login.createForm = createForm;
    login.processQr = processQr;
    login.loginLastUser = loginLastUser;
    login.getTranslationsWithoutLogin = getTranslationsWithoutLogin;

    /* Load Client Fragment Content */
    checkReady();
    $.get(window.RCA.shared.url_rewrite + 'modules/mod_login.html', login._ajaxReadyModClient);
})(window.RCA.login);
